import React from 'react';
import styled from 'styled-components';
import {useTheme} from 'styled-components';
import {
  mdiInformation,
  mdiTriangle,
  mdiOctagon,
  mdiSquare,
  mdiSyncAlert,
  mdiInformationOutline,
  mdiAlertOutline,
  mdiAlertBoxOutline,
  mdiAlertOctagonOutline,
} from '@mdi/js';
import {SeverityPriorityEnum} from 'features/POSRegisters/interfaces/Severity';

//# region interfaces

interface SeverityBadgeProps {
  severity: string;
  size?: number;
  className?: string;
}
//# endregion interfaces

//#region styles
const StyledIcon = styled.svg`
  flex-shrink: 0;
`;
//#endregion styles

//#region functions
const getIconStyle = function getIconStyle(priority: number, theme: any) {
  switch (priority) {
    case SeverityPriorityEnum.INFORMATIONAL: {
      return {
        shape: mdiInformation,
        icon: mdiInformationOutline,
        stroke: theme.white,
        iconStroke: theme.white,
        backgroundColor: theme.blue,
        iconSize: 'scale(1)',
      };
    }
    case SeverityPriorityEnum.SCANFAILURE: {
      return {
        shape: mdiSquare,
        icon: mdiSyncAlert,
        stroke: theme.informationalBlue,
        iconStroke: theme.white,
        backgroundColor: theme.informationalBlue,
        // makes the svg icon smaller and centered
        iconSize: 'scale(0.7) translate(5.5,5.5)',
      };
    }
    case SeverityPriorityEnum.MINOR: {
      return {
        shape: mdiTriangle,
        icon: mdiAlertOutline,
        stroke: theme.white,
        iconStroke: theme.white,
        backgroundColor: theme.yellow,
        iconSize: 'scale(1)',
      };
    }
    case SeverityPriorityEnum.MAJOR: {
      return {
        shape: mdiSquare,
        icon: mdiAlertBoxOutline,
        stroke: theme.white,
        iconStroke: theme.white,
        backgroundColor: theme.orange,
        iconSize: 'scale(1)',
      };
    }
    case SeverityPriorityEnum.CRITICAL: {
      return {
        shape: mdiOctagon,
        icon: mdiAlertOctagonOutline,
        stroke: theme.white,
        iconStroke: theme.white,
        backgroundColor: theme.red,
        iconSize: 'scale(1)',
      };
    }
    default:
      return {
        shape: undefined,
        icon: undefined,
        stroke: 'transparent',
        iconStroke: 'transparent',
        backgroundColor: 'transparent',
      };
  }
};
//#endregion functions

export default function SeverityBadge({className, severity, size = 1}: SeverityBadgeProps) {
  const theme = useTheme();
  const priority = SeverityPriorityEnum[severity.toUpperCase()];
  const {icon, shape, iconSize, stroke, iconStroke, backgroundColor} = getIconStyle(
    priority,
    theme
  );

  return (
    <StyledIcon
      className={className}
      width={`${size * 1.5}rem`}
      height={`${size * 1.5}rem`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d={shape} fill={backgroundColor} stroke={stroke} fillRule="evenodd" />
      <path transform={iconSize} d={icon} fill={iconStroke} />
    </StyledIcon>
  );
}
